import styled from 'styled-components';
import { COMMON, LAYOUT, POSITION, TYPOGRAPHY } from '../constants';
/**
 * flex method doesn't work for IE so Absolute is used as a fallback
 * rules don't conflict so no need for detecting browsers
 */

const AvatarInitials = styled.span.withConfig({
  displayName: "AvatarInitials",
  componentId: "sc-17mklou-0"
})(["", ";", ";", ";", ";display:flex;align-items:center;justify-content:center;line-height:1;"], COMMON, LAYOUT, POSITION, TYPOGRAPHY);
AvatarInitials.defaultProps = {
  position: 'absolute',
  top: 0,
  left: 0,
  // padding top to account for harmonia sans baseline issue
  pt: 1,
  color: 'text.black'
};
AvatarInitials.propTypes = { ...COMMON.propTypes,
  ...LAYOUT.propTypes,
  ...POSITION.propTypes
};
AvatarInitials.displayName = 'AvatarInitials';
export default AvatarInitials;